// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__pQTCp","approved":"Status_approved__1KnQB","rejected":"Status_rejected__DkE7m","expired":"Status_expired__1vMMb","label":"Status_label__1Foqo"};